.verification {
    display: flex;
    flex-direction: column;
    gap: var(--bi-scale-6x);
    font: var(--bi-font-body-large);
    color: var(--bi-primary-90);

    li {
        list-style-type: circle;
        list-style-position: inside;
        padding-left: var(--bi-scale-2x);
    }
}

.form {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: var(--bi-scale-4x);
}
